import setSliderSettings from '../../js/components/slider.js';

( () => {

	/**
	 * Block name
	 *
	 * @type {string}
	 */
	const blockName = 'a-z-index';

	/**
	 * Init
	 */
	window.addEventListener( 'load', () => {

		const blocks = document.querySelectorAll( `.block-${ blockName }` );
		if ( blocks.length > 0 ) {

			blocks.forEach( ( block ) => {

				initializeBlock( block );

			} );

		}

	} );

	/**
	 * Initialize slider
	 *
	 * @param {object} block
	 */
	const initSlider = ( block ) => {

		const slider = block.querySelector( '.wombat-slider-container' );
		// inititalize slider
		if ( slider ) {

			setSliderSettings( slider );

		}

	}

	/**
	 * Set current letter
	 *
	 * @param {object} block
	 */
	const setCurrentLetter = ( block ) => {

		const letters = block.querySelectorAll( '.table-of-content__letter' );
		const currentLetter = window.location.hash;

		if ( letters.length > 0 ) {

			document.querySelector( 'html' ).style.scrollBehavior = 'smooth';

			letters.forEach( ( letter ) => {

				if ( currentLetter && letter.innerText.toLowerCase() === currentLetter.slice( 1 ).toLowerCase() ) {

					letter.classList.add( 'current-letter' );

				}

				letter.addEventListener( 'click', () => {

					const clickedLetter = block.querySelector( '.current-letter' );

					if ( clickedLetter ) {

						clickedLetter.classList.remove( 'current-letter' );

					}

					letter.classList.add( 'current-letter' );

				} );

			} );

		}

	}

	/**
	 * Block init
	 *
	 * @param {object} block
	 */
	const initializeBlock = ( block ) => {

		if ( block[ 0 ] !== undefined ) {

			block = block[ 0 ].querySelector( `.block-${ blockName }` );

		}
		if ( block === false || block === null ) {}

		// Block Code Here
		initSlider( block );
		setCurrentLetter( block );

	};

} )();
